import { render, staticRenderFns } from "./confirmed.vue?vue&type=template&id=3c1af1b9&"
import script from "./confirmed.vue?vue&type=script&lang=js&"
export * from "./confirmed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports